import { render } from "./DbEntitiesList.vue?vue&type=template&id=f4b62afe&scoped=true"
import script from "./DbEntitiesList.vue?vue&type=script&lang=js"
export * from "./DbEntitiesList.vue?vue&type=script&lang=js"

import "./DbEntitiesList.vue?vue&type=style&index=0&id=f4b62afe&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b62afe"]])

export default __exports__